import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class CreditGeniusService {

  constructor(private api: ApiService) { }

  VerifyUserAvailability(userValidateData:any)
  {
    return this.api.post('creditgenius/VerifyUserAvailable', userValidateData);
  }

  SavePersonalDetail(userProfileData:any)
  {    
    return this.api.post('creditgenius/SavePersonalDetails', userProfileData);
  }

  SaveUserAddress(addressData:any) {
    return this.api.post('creditgenius/SaveAddressDetail', addressData);
  }

  SaveUserAdditionalInfo(additionalInfo:any) {
    return this.api.post('creditgenius/SaveAdditionalInfo', additionalInfo);
  }

  GetHomeOwnership() {
    return this.api.get('creditgenius/HomeOwnership');
  }

  GetEmploymentStatus() {
    return this.api.get('creditgenius/EmploymentStatus');
  }

  GetMaritalStatus() {
     return this.api.get('creditgenius/MaritalStatus');
  }

  GetIndustry() {
    return this.api.get('creditgenius/Industry');
  }  

  GetAddress(postcode:any): Observable<any> {
    let random = Math.random().toString().replace(".", "");
    return this.api.get('creditgenius/GetAddress/' + encodeURIComponent(postcode)+'?key='+random); 
  }

  GetEligibilityBasedLoan(loanRequestModel:any) {
    return this.api.post('creditgenius/EligibilityBasedLoans', loanRequestModel);
  }

  LoanRequestLogger(loanRequestModel:any) {
    return this.api.post('creditgenius/LoanRequestLogger', loanRequestModel);
  }
  

  GetFinancialMasterData() {
    return this.api.get('creditgenius/financialmasterdata');
  }

  GetTooltip() {
    return this.api.get('creditgenius/Tooltip');
  }

  RegistrationRequest(registrationRequest:any) {
    return this.api.post('creditgenius/RegistrationRequest', registrationRequest);
  }

  SavePrimeInfo(primeInfoModel:any) {
    return this.api.post('creditgenius/SaveSubPrimeAdditionalInfo', primeInfoModel);
  }

  GetAllDetails(Customer:any): Observable<any> {
    return this.api.get('creditgenius/GetUserAllDetail/'+'?CustomerId='+Customer); 
  }

  CheckStatusPingYo(statusRequest:any) {
    return this.api.post('creditgenius/CheckStatus', statusRequest);
  }
  
}
